import { MarketplaceId } from '@rome/request/marketplace/MarketplaceId';
import ApiCaller from '../ApiCaller';
import baseAjaxConfig from '../BaseAjaxConfig';
export var MOVE_TO_SFL_FROM_CART;
(function (MOVE_TO_SFL_FROM_CART) {
    MOVE_TO_SFL_FROM_CART["REQUEST"] = "MOVE_TO_SFL_FROM_CART_REQUEST";
    MOVE_TO_SFL_FROM_CART["SUCCESS"] = "MOVE_TO_SFL_FROM_CART_SUCCESS";
    MOVE_TO_SFL_FROM_CART["ERROR"] = "MOVE_TO_SFL_FROM_CART_ERROR";
})(MOVE_TO_SFL_FROM_CART || (MOVE_TO_SFL_FROM_CART = {}));
export function moveToSFLAction(listingIds = [], isMarketPlace = false) {
    const requestPayload = isMarketPlace
        ? { marketPlaces: [MarketplaceId.GROCERY] }
        : { items: listingIds.map(listingId => ({ listingId })) };
    return (dispatch) => {
        if (!isMarketPlace && !listingIds.length) {
            return Promise.reject('');
        }
        dispatch({
            type: MOVE_TO_SFL_FROM_CART.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/5/cart/move',
            action: MOVE_TO_SFL_FROM_CART.REQUEST
        }), requestPayload)
            .then(data => {
            dispatch({
                type: MOVE_TO_SFL_FROM_CART.SUCCESS,
                data: data.RESPONSE
            });
            return data;
        })
            .catch(err => {
            dispatch({
                type: MOVE_TO_SFL_FROM_CART.ERROR,
                error: err
            });
            return Promise.reject(err);
        });
    };
}
export var MOVE_TO_CART_FROM_SFL;
(function (MOVE_TO_CART_FROM_SFL) {
    MOVE_TO_CART_FROM_SFL["REQUEST"] = "MOVE_TO_CART_FROM_SFL_REQUEST";
    MOVE_TO_CART_FROM_SFL["SUCCESS"] = "MOVE_TO_CART_FROM_SFL_SUCCESS";
    MOVE_TO_CART_FROM_SFL["ERROR"] = "MOVE_TO_CART_FROM_SFL_ERROR";
})(MOVE_TO_CART_FROM_SFL || (MOVE_TO_CART_FROM_SFL = {}));
export function moveSFLToCartAction(listingId, isMarketPlace = false) {
    const requestPayload = isMarketPlace ? { marketPlaces: [MarketplaceId.GROCERY] } : { items: [{ listingId }] };
    return (dispatch) => {
        dispatch({
            type: MOVE_TO_CART_FROM_SFL.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/5/sfl/move',
            acceptErrors: true,
            action: MOVE_TO_CART_FROM_SFL.REQUEST
        }), requestPayload)
            .then(data => {
            dispatch({
                type: MOVE_TO_CART_FROM_SFL.SUCCESS,
                data: {
                    response: data.RESPONSE,
                    listingId
                }
            });
        })
            .catch(err => {
            dispatch({
                type: MOVE_TO_CART_FROM_SFL.ERROR,
                error: err
            });
            return Promise.reject(err);
        });
    };
}
export var GET_SAVE_FOR_LATER;
(function (GET_SAVE_FOR_LATER) {
    GET_SAVE_FOR_LATER["REQUEST"] = "GET_SAVE_FOR_LATER_REQUEST";
    GET_SAVE_FOR_LATER["SUCCESS"] = "GET_SAVE_FOR_LATER_SUCCESS";
    GET_SAVE_FOR_LATER["ERROR"] = "GET_SAVE_FOR_LATER_ERROR";
})(GET_SAVE_FOR_LATER || (GET_SAVE_FOR_LATER = {}));
export function fetchSaveForLaterAction(pincode = '') {
    const query = {};
    pincode && (query.pincode = pincode);
    return (dispatch) => {
        dispatch({
            type: GET_SAVE_FOR_LATER.REQUEST
        });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/5/sfl',
            query,
            action: GET_SAVE_FOR_LATER.REQUEST,
            acceptErrors: true
        }))
            .then(data => {
            return dispatch({
                type: GET_SAVE_FOR_LATER.SUCCESS,
                data: data.RESPONSE
            });
        })
            .catch(err => {
            dispatch({
                type: GET_SAVE_FOR_LATER.ERROR,
                error: err
            });
            return Promise.reject(err);
        });
    };
}
export var REMOVE_FROM_SFL;
(function (REMOVE_FROM_SFL) {
    REMOVE_FROM_SFL["REQUEST"] = "REMOVE_FROM_SFL";
    REMOVE_FROM_SFL["SUCCESS"] = "REMOVE_FROM_SFL_SUCCESS";
    REMOVE_FROM_SFL["ERROR"] = "REMOVE_FROM_SFL_ERROR";
})(REMOVE_FROM_SFL || (REMOVE_FROM_SFL = {}));
export function removeFromSFLAction(listingIds = [], isMarketPlace = false) {
    if (!isMarketPlace && !listingIds.length) {
        return Promise.reject('');
    }
    const query = isMarketPlace ? { marketplaceIds: MarketplaceId.GROCERY } : { listingIds: listingIds.join(',') };
    return (dispatch) => {
        dispatch({
            type: REMOVE_FROM_SFL.REQUEST
        });
        return ApiCaller.delete(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/5/sfl',
            acceptErrors: true,
            action: REMOVE_FROM_SFL.REQUEST,
            query
        }))
            .then(data => {
            return dispatch({
                type: REMOVE_FROM_SFL.SUCCESS,
                data: data.RESPONSE
            });
        })
            .catch(err => {
            dispatch({
                type: REMOVE_FROM_SFL.ERROR,
                error: err
            });
            return Promise.reject(err);
        });
    };
}
